export default "assets/images/icons/back-9915044e.svg";